import {
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBRow,
} from "mdb-react-ui-kit";
import styles from "@/styles/common/Wishlist.module.scss";
import { useIsMD } from "@/hooks/useWindowSizes";
import ContactCard from "@/components/contacts/ContactCard";
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import Link from "next/link";
import useContactsData from "@/utils/queries/hooks/useContactsData";
import { getContactsInfo } from "@/utils/mockData/contactsMocks";

const TalkWithUs: FC<{
    show: boolean;
    setShow: Dispatch<SetStateAction<boolean>>;
}> = ({ show, setShow }) => {
    const [isBrowser, setIsBrowser] = useState(false);
    const { data: contactsData } = useContactsData();

    const contactsInfo = getContactsInfo(contactsData || {});

    useEffect(() => {
        setIsBrowser(typeof window !== "undefined");
    }, []);
    const isMD = useIsMD();

    return isBrowser ? (
        <MDBModal show={show} setShow={setShow} tabIndex="-1">
            <MDBModalDialog centered size={isMD ? "fullscreen" : "xl"}>
                <MDBModalContent
                    style={{
                        borderRadius: isMD ? "0px" : "24px",
                        backgroundColor: "#f5f5f5",
                    }}
                >
                    <MDBModalHeader className="position-relative border border-0 d-flex justify-content-center px-md-5 py-5 mx-4">
                        {/* <MDBModalTitle
                            className={`${styles.modalTitle} fw-bold`}
                            style={{ color: "#ed6f6f" }}
                        >
                            Talk with us
                        </MDBModalTitle> */}
                        <MDBBtn
                            className={`${styles.closeButton} btn-close`}
                            color="none"
                            onClick={() => setShow(false)}
                        />
                    </MDBModalHeader>
                    <MDBModalBody
                        className={`${styles.contentBody}  mx-md-4 d-flex flex-row justify-content-between pb-0`}
                    >
                        <MDBRow around>
                            {contactsInfo?.map(contact => (
                                <ContactCard
                                    key={contact.id}
                                    contactInfo={contact}
                                />
                            ))}
                        </MDBRow>
                    </MDBModalBody>

                    <MDBModalFooter className="border border-0 d-flex justify-content-center fw-bold pt-0 mb-3">
                        <p className={styles.textCaption}>
                            {" "}
                            Do you need more info?{" "}
                            <Link
                                href="/faq"
                                style={{ color: "#ed6f6f" }}
                                onClick={() => setShow(false)}
                            >
                                Check our FAQ page.
                            </Link>
                        </p>
                    </MDBModalFooter>
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    ) : (
        <div />
    );
};
export default TalkWithUs;
